module.exports = __webpack_public_path__ + "img/loading.3990e106.gif";